import axios from 'axios';

const table = body => {
    return axios.post('/news-tables', body).then(
        response => {
            const { table } = response.data;

            return table;
        },
        error => {
            const { response } = error;
            const { data } = response;
            const { errors } = data;

            return Promise.reject(errors);
        }
    );
};

const create = body => {
    return axios.post('/news', body).then(
        response => {
            const { news } = response.data;

            return news;
        },
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

const edit = (id, body) => {
    return axios.put('/news/' + id, body).then(
        response => {
            const { news } = response.data;

            return news;
        },
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

const find = id => {
    return axios.get('/news/' + id).then(
        response => {
            const { news } = response.data;

            return news;
        },
        error => {
            const { response } = error;
            const { data } = response;
            const { errors } = data;

            return Promise.reject(errors);
        }
    );
};

const remove = id => {
    return axios.delete('/news/' + id).then(
        () => {},
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

export const newsServices = {
    table,
    create,
    edit,
    find,
    remove
};
